import React, { useState } from 'react'
import { Table } from 'react-bootstrap'
import ToggleBar from '../../commoncomponents/toggleBar'
import { utcToReportDate } from '../../../utils/dateConvert'
import { downloadCSVFile } from '../../../api/apiClient'
import Location from '../../commoncomponents/location'
import { GetLocationAddress } from '../../../utils/mapapi'
import { formatTemperatureReading, sanitizeTemperatureReadings, temperatureReadingClass } from '../../../utils/temperature'

function VirtualTrips(props) {
  const [tempABoolean] = useState(props.reportDetail[0] && props.reportDetail[0].tempAStart !== null);
  const [tempBBoolean] = useState(props.reportDetail[0] && props.reportDetail[0].tempBStart !== null);
  let assetName = props.assetCustomerName;
  let assetId = props.assetId;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';

  const data = (
    <React.Fragment>
      <Table responsive striped>
        <thead>
          <tr className="nowwrapTH">
            <th>ID</th>
            <th>Started</th>
            <th>Completed</th>
            <th>Duration</th>
            <th>Address</th>
            {tempABoolean && <th>Temp A (Trigger)</th>}
            {tempBBoolean && <th>Temp B (Trigger)</th>}
            <th>Fridge (Trigger)</th>
            {tempABoolean && <th>Temp A (End)</th>}
            {tempBBoolean && <th>Temp B (End)</th>}

            <th>Fridge (End)</th>
          </tr>
        </thead>
        <tbody>
          {props.reportDetail.map((item, index) => {
            return (

              <tr key={index}>
                <td>{++index}</td>
                <td>{utcToReportDate(item.started)}</td>
                <td>{utcToReportDate(item.completed)}</td>
                <td>{item.duration}</td>
                <td>
                  <Location
                    address={item.address}
                    lat={item.latitude}
                    lng={item.longitude}
                  />
                </td>
                {tempABoolean && <td className={temperatureReadingClass(item.tempAStart)}>{formatTemperatureReading(item.tempAStart)}</td>}
                {tempBBoolean && <td className={temperatureReadingClass(item.tempBStart)}>{formatTemperatureReading(item.tempBStart)}</td>}
                <td>{item.fridgeStart ? "On" : "Off"}</td>
                {tempABoolean && <td className={temperatureReadingClass(item.tempAEnd)}>{formatTemperatureReading(item.tempAEnd)}</td>}
                {tempBBoolean && <td className={temperatureReadingClass(item.tempBEnd)}>{formatTemperatureReading(item.tempBEnd)}</td>}
                <td>{item.fridgeEnd ? "On" : "Off"}</td>


              </tr>
            )
          })}
        </tbody>
      </Table>
    </React.Fragment>
  )

  const ReportDetailWithlocation = async () =>{
    const updatedDetails = await Promise.all(
      props.reportDetail.map(async (item) => {
        if (item.latitude && item.longitude && !item.address
        ) {
          try {
            const address = await GetLocationAddress(item.latitude, item.longitude);
            item.address = address;
          } catch (e) {
            item.address = `${item.latitude}, ${item.longitude}`;
          }
        }
        return item;
      })
  );
  return updatedDetails;
  }

  const handleDownloadExcel = async () => {
    let reportData = await ReportDetailWithlocation();
    downloadCSVFile(reportData.map(sanitizeTemperatureReadings), "VirtualTrips", assetName, timeZone, assetId);
  }

  return (
    <ToggleBar caption="Virtual Trips" download={handleDownloadExcel} icon="fa-building-o" color="#337ab7" content={data} />
  )
}

export default VirtualTrips
